import styled from 'styled-components';
import { SelectableTileProps } from './types';

export const Container = styled.div<SelectableTileProps>`
  border: none;
  display: flex;
  overflow: hidden;

  width: 100%;
  height: ${({ theme }) => theme.spacing['8Xl']};

  border-radius: ${({ theme }) => theme.borderRadius.md};
  background: ${({ theme }) => theme.background.default};

  ${({ theme, selected }) =>
    theme.innerAlignBorder(
      selected ? theme.border.sm : theme.border.xs,
      selected ? theme.border.strong : theme.border.weak,
      false,
    )}

  cursor: pointer;

  &:not(:disabled):hover {
    ${({ theme }) => theme.innerAlignBorder(theme.border.sm, theme.border.default, false)}
  }

  &:not(:disabled):active {
    ${({ theme }) => theme.innerAlignBorder(theme.border.sm, theme.border.strong, false)}
  }

  &:disabled {
    cursor: default;
    ${({ theme, selected }) =>
      theme.innerAlignBorder(
        theme.border.xs,
        selected ? theme.border.default : theme.border.disabled,
        false,
      )}
    background: ${({ theme }) => theme.background.disabledSubtle};
    color: ${({ theme }) => theme.text.disabled};
  }
`;
